import { NominalPaymentsComponent } from '@app/components/apps/NominalPayments/NominalPaymentsComponent';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { Col, Row, Button as BaseButton } from 'antd';
import { useEffect, useState } from 'react';

const routes = [
  { path: '/nominal-payments', breadcrumbName: 'Nominal Payments' },
  { path: '/add-nominal-payment', breadcrumbName: 'Add Nominal Payment' },
];

const CreateNominalPayment = () => {
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Add Nominal Payment');
  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(currentBreadcrumName);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <NominalPaymentsComponent
          editable={true}
          pageTitle={'Create Nominal Payment'}
          type={'create'}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Col>
    </Row>
  );
};

export default CreateNominalPayment;
